import { useCallback } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { ApiError } from "../../api/client";
import { meApi } from "../../api/me";
import type { UserOut } from "../../api/types";

export const ME_KEY = ["me"] as const;

/** The logged-in user, or null when the session is missing. */
export function useMe() {
  return useQuery<UserOut | null>({
    queryKey: ME_KEY,
    queryFn: async () => {
      try {
        return await meApi.get();
      } catch (err) {
        if (err instanceof ApiError && err.status === 401) return null;
        throw err;
      }
    },
    staleTime: 30_000,
  });
}

export function useInvalidateMe() {
  const queryClient = useQueryClient();
  // Stable identity: pages call it from effects, and a fresh function per render re-runs them.
  return useCallback(
    () => queryClient.invalidateQueries({ queryKey: ME_KEY }),
    [queryClient],
  );
}
